import { Textarea } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useChartSchema } from '@/entities/dashboards';
import { ChartSchemaReference } from './ChartSchemaReference';

type Props = {
  /** Запрос диаграммы — как его составила система или правит пользователь */
  query: string;
  onChange: (query: string) => void;
};

/**
 * Запрос диаграммы и справочник витрины, по которому он пишется.
 *
 * Блок показывается только при разрешении на правку запроса: запрос читает данные диалогов в
 * обход интерфейсов системы, поэтому право видеть его отделено от права строить дашборды.
 * Правленый запрос заверяется сохранением свойств диаграммы — описание при этом заново не
 * истолковывается. Текст результата разрешением не закрыт и правится в самой форме свойств.
 */
export const ChartQueryEditor: FC<Props> = ({ query, onChange }) => {
  const { t } = useTranslation('qualityDashboard');
  const { data: schema, isLoading } = useChartSchema();

  return (
    <div className="flex flex-col gap-3 rounded-md border p-3">
      <Textarea
        label={t('presets.editor.chartQuery')}
        description={t('presets.editor.chartQueryHint')}
        value={query}
        onChange={(event) => onChange(event.target.value)}
        rows={6}
        classNames={{ input: 'font-mono text-xs' }}
      />

      <ChartSchemaReference schema={schema} isLoading={isLoading} />
    </div>
  );
};
